module.exports = __webpack_public_path__ + "img/whatIsUrbanMining.28857fb.jpg";